import { Controller } from 'stimulus';

export default class DateInputController extends Controller {
  static targets = ['startDate', 'endDate', 'tab'];

  connect() {
    this._handleDateSelected(this.startDateTarget);
    this._handleDateSelected(this.endDateTarget);

    this.form = this.element.closest('form');

    this.form.addEventListener('reset', this._handleFormReset);
  }

  disconnect() {
    this.form.removeEventListener('reset', this._handleFormReset);
  }

  openPicker = ({ target } = {}) => {
    target.showPicker();
  };

  dateSelected = ({ target } = {}) => {
    for (const tab of this.tabTargets) {
      tab.removeAttribute('checked');
    }
    this._handleDateSelected(target);
  };

  dateTabSelected = ({ target } = {}) => {
    const selectedDateTab = target.value;

    switch (selectedDateTab) {
      case 'today':
        this._handleTodaySelected();
        break;
      case 'tomorrow':
        this._handleTomorrowSelected();
        break;
      case 'this_weekend':
        this._handleThisWeekendSelected();
        break;
      default:
        break;
    }
  };

  _handleTodaySelected = () => {
    const today = new Date();
    this._setDateRange(today, today);
  };

  _handleTomorrowSelected = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    this._setDateRange(tomorrow, tomorrow);
  };

  _handleThisWeekendSelected = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();

    let startDate, endDate;

    if (dayOfWeek === 6) {
      startDate = new Date(today);
      endDate = new Date(today);
      endDate.setDate(endDate.getDate() + 1);
    } else if (dayOfWeek === 0) {
      startDate = new Date(today);
      startDate.setDate(startDate.getDate() - 1);
      endDate = new Date(today);
    } else {
      const daysUntilSaturday = 6 - dayOfWeek;
      startDate = new Date(today);
      startDate.setDate(today.getDate() + daysUntilSaturday);

      endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + 1);
    }

    this._setDateRange(startDate, endDate);
  };

  _setDateRange = (start, end) => {
    this.startDateTarget.value = this._formatDate(start);
    this.endDateTarget.value = this._formatDate(end);

    this._handleDateSelected(this.startDateTarget);
    this._handleDateSelected(this.endDateTarget);
  };

  _handleDateSelected = (input) => {
    input.value
      ? input.classList.add('selected')
      : input.classList.remove('selected');
  };

  _formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  _handleFormReset = () => {
    setTimeout(() => {
      this._handleDateSelected(this.startDateTarget);
      this._handleDateSelected(this.endDateTarget);
    }, 0);
  };
}
